import React from "react";
import { SkeletonWrap, SkeletonCard, Circle, Line } from "./styles";

const HypervisorSummarySkeleton = () => {
  return (
    <SkeletonWrap>
      <div className="row-3">
        <SkeletonCard>
          <Line width="20%" />
          <Line width="30%" />
          <Circle />
        </SkeletonCard>
        <SkeletonCard>
          <Line width="20%" />
          <Line width="30%" />
          <Circle />
        </SkeletonCard>
        <SkeletonCard>
          <Line width="20%" />
          <Line width="30%" />
          <Circle />
        </SkeletonCard>
      </div>

      <div className="row-2">
        <SkeletonCard>
          <Line width="10%" />
          <Circle />
        </SkeletonCard>
        <SkeletonCard>
          <Line width="10%" />
          <Circle />
        </SkeletonCard>
      </div>
    </SkeletonWrap>
  );
};

export default HypervisorSummarySkeleton;
